// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"98cec2db","378":"77e7531d","383":"6a16127c"}[chunkId] + ".js";
};